export var CONDITIONAL_SUBMIT_FLAG = '@@ddf-common-wizard__conditional-submit-step';